import { Text, type TextProps } from "tamagui";
import tamaguiConfig from "../../tamagui.config";
import { Input, type InputProps } from "./InputNew";
import { Skeleton } from "./Skeleton";

const bodyStyle = {
  fontFamily: "$body",
  fontWeight: "$true",
  lineHeight: "$true",
  fontSize: "$true",
} as const;

export const Body = ({
  children,
  muted,
  ...props
}: { children: React.ReactNode; muted?: boolean } & TextProps) => {
  return (
    <Text {...bodyStyle} color={muted ? "$muted" : "$color"} {...props}>
      {children}
    </Text>
  );
};

export const BodyTextarea: React.FC<
  InputProps & {
    muted?: boolean;
    strikeThrough?: boolean;
  }
> = ({ muted, strikeThrough, ...props }) => {
  return (
    <Input
      {...bodyStyle}
      backgroundColor="transparent"
      textDecorationLine={strikeThrough ? "line-through" : undefined}
      color={muted ? "$muted" : "$color"}
      {...props}
    />
  );
};

export const BodySkeleton: React.FC = () => {
  const appConfig = tamaguiConfig;
  return (
    <Skeleton width={"100%"} height={appConfig.fonts.body.lineHeight.true} />
  );
};
